/* eslint-disable camelcase */
import request from 'superagent'
import types from '../types'
import Authorization from '../../types/Authorization'

import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if(api_port==='')
  apiUrl = `${protocol}//${hostname}/api`

const getAuthorizationsRequested = (type: string) => ({
  type: types.GET_AUTHORIZATIONS_REQUESTED,
  payload: null,
  authType: type
})

const getAuthorizationsRejected = (error: any, type: string) => ({
  type: types.GET_AUTHORIZATIONS_REJECTED,
  payload: error,
  authType: type
})

const getAuthorizationsFulfilled = (data: Array<Authorization>, type: string) => ({
  type: types.GET_AUTHORIZATIONS_FULFILLED,
  payload: data,
  authType: type
})

export const getAuthorizations = (id: number, page: number, sizePerPage: number, searchTerm: string, startDate: string, endDate: string, filterByAuthStatus: string, sortField: string, sortOrder: string, endDateFrom: string, endDateTo: string, type: string, token: string) => {
  return (dispatch: any) => {
    dispatch(getAuthorizationsRequested(type))
    request
      .post(`${apiUrl}/authorizations/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .send({
        page,
        sizePerPage,
        searchTerm,
        startDate,
        endDate,
        filterByAuthStatus,
        sortField,
        sortOrder,
        endDateTo,
        endDateFrom,
        type
      })
      .then((response) => {
        dispatch(getAuthorizationsFulfilled(response.body, type))
      })
      .catch((error) => {
        dispatch(getAuthorizationsRejected(error, type))
      })
  }
}

const getOrgAuthorizationsRequested = (type: string) => ({
  type: types.GET_ORG_AUTHORIZATIONS_REQUESTED,
  payload: null,
  authType: type
})

const getOrgAuthorizationsRejected = (error: any, type: string) => ({
  type: types.GET_ORG_AUTHORIZATIONS_REJECTED,
  payload: error,
  authType: type
})

const getOrgAuthorizationsFulfilled = (data: Array<Authorization>, type: string) => ({
  type: types.GET_ORG_AUTHORIZATIONS_FULFILLED,
  payload: data,
  authType: type
})

export const getOrgAuthorizations = (id: number, page: number, sizePerPage: number, searchTerm: string, startDate: string, endDate: string, filterByAuthStatus: string, sortField: string, sortOrder: string, endDateFrom: string, endDateTo: string, type: string, token: string) => {
  return (dispatch: any) => {
    dispatch(getOrgAuthorizationsRequested(type))
    request
      .post(`${apiUrl}/org/authorizations`)
      .send({
        organizationId: id,
        page,
        sizePerPage,
        searchTerm,
        startDate,
        endDate,
        filterByAuthStatus,
        sortField,
        sortOrder,
        endDateTo,
        endDateFrom,
        type
      })
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getOrgAuthorizationsFulfilled(response.body, type))
      })
      .catch((error) => {
        dispatch(getOrgAuthorizationsRejected(error, type))
      })
  }
}

export const clearCSVAuth = (csvType: string) => ({
  type: types.CLEAR_CSV_AUTHORIZATIONS,
  csvType
})